import { render, staticRenderFns } from "./InstitucionList.vue?vue&type=template&id=7f7beedf&"
import script from "./InstitucionList.vue?vue&type=script&lang=js&"
export * from "./InstitucionList.vue?vue&type=script&lang=js&"
import style0 from "./InstitucionList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports